import { useState } from "react";
import { useParams } from "react-router";
import { useSingleProject } from "../../actions/homeActions";
import localimgpath from "../../js/localimgpath";
export default () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { id } = useParams();
  const { data: project, isLoading, isError, error } = useSingleProject(id);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading project details: {error.message}
        </p>
      </div>
    );
  }
  const galleryImages = project?.galleries?.map((item) => ({
    original: `${localimgpath?.projectsGallery}/${item?.image}`,
    thumbnail: `${localimgpath?.projectsGallery}/${item?.image}`,
    originalAlt: item?.title || "Gallery Image",
    description: item?.title || "",
  }));

  const openGallery = (index) => {
    setSelectedIndex(index);
    setIsOpen(true);
  };

  const closeGallery = () => setIsOpen(false);
  return {
    isLoading,
    project,
    localimgpath,
    openGallery,
    isOpen,
    closeGallery,
    galleryImages,
    selectedIndex,
  };
};
